import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Collapse from '@mui/material/Collapse';
import Card from '@mui/material/Card';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import makeStyles from '@mui/styles/makeStyles';
import { grey } from '@mui/material/colors';

const useStyles = makeStyles(theme => ({
  head: {
    position: 'relative',
    minHeight: 50,
  },
  icon: {
    backgroundColor: grey[300],
    borderRadius: '50%',
    padding: 3,
    color: '#fff',
    transform: 'translateY(-50%) rotate(90deg)',
    boxSizing: 'content-box',
    cursor: 'pointer',
    position: 'absolute',
    right: 15,
    top: '50%',
    transition: 'transform 300ms',
  },
  iconActive: {
    transform: 'translateY(-50%) rotate(270deg)',
    backgroundColor: theme.palette.primary.main,
  },
}));

const CollapseCard = ({ isOpen, head, children, ...props }) => {
  const [isIn, setIsIn] = useState(isOpen);
  const classes = useStyles();

  const iconClasses = clsx(classes.icon, {
    [classes.iconActive]: isIn,
  });
  const handleClick = () => setIsIn(!isIn);

  return (
    <Card {...props}>
      <div className={classes.head}>
        {head}
        <DoubleArrowIcon className={iconClasses} onClick={handleClick} />
      </div>
      <Collapse in={isIn}>{children}</Collapse>
    </Card>
  );
};

CollapseCard.defaultProps = {
  isOpen: false,
};

CollapseCard.propTypes = {
  isOpen: PropTypes.bool,
  head: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default CollapseCard;
